import { Typography, useMediaQuery, useTheme } from '@mui/material'
import { StudentThankYouScreenContent, FeedbackType } from 'utils/constants'
import type { DetailedFeedbackScreenProps } from './feedbackTypes'
import {
    FeedbackCard,
    FeedbackTextGroup,
    ThumbsUpIcon,
    ThumbsDownIcon,
    DetailedFeedbackOptionsWrapper,
    DetailedOptionButtonsWrapper,
    DetailedOptionButton,
    BackButton
} from './feedbackStyles'

export const DetailedFeedbackScreen: React.FC<DetailedFeedbackScreenProps> = ({
    selectedFeedback,
    selectedOption,
    onOptionSelect,
    onBack,
    question,
    options
}) => {
    const theme = useTheme()
    const isMobileOrSmall = useMediaQuery(theme.breakpoints.down('md'))
    const buttonSize = isMobileOrSmall ? 'large' : 'small'

    const isPositive = selectedFeedback === FeedbackType.POSITIVE
    const content = isPositive
        ? StudentThankYouScreenContent.positiveFeedback
        : StudentThankYouScreenContent.negativeFeedback

    return (
        <FeedbackCard elevation={0}>
            <FeedbackTextGroup>
                <Typography variant='subtitle1' color={'text.secondary'}>
                    {content.thankYou}
                </Typography>
                <Typography variant='subtitle1' color={'text.secondary'}>
                    {question}
                </Typography>
            </FeedbackTextGroup>
            {isPositive ? <ThumbsUpIcon /> : <ThumbsDownIcon />}
            <DetailedFeedbackOptionsWrapper>
                <DetailedOptionButtonsWrapper>
                    {options.map((option: string) => (
                        <DetailedOptionButton
                            key={option}
                            size={buttonSize}
                            selected={selectedOption === option}
                            onClick={() => onOptionSelect(option)}
                            variant='outlined'
                        >
                            <Typography variant='subtitle2'>{option}</Typography>
                        </DetailedOptionButton>
                    ))}
                </DetailedOptionButtonsWrapper>
                <BackButton onClick={onBack}>
                    {StudentThankYouScreenContent.backButton}
                </BackButton>
            </DetailedFeedbackOptionsWrapper>
        </FeedbackCard>
    )
}
